import {HttpHeaders, HttpParams} from '@angular/common/http'

export class UserSettings {

  public static headers() {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + localStorage.getItem('userToken'),
      'Access-Control-Allow-Origin': '*'
    })
    return httpHeaders
  }

}
